import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    transform: translate(-40%,-128%);\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: 0;\n  color: #4F6E7C;\n  font-size: 12px;\n  line-height: 100%;\n  background: #000000;\n  width: fit-content;\n  padding: 6px 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transform: translate(-40%, -140%);\n  white-space: nowrap;\n  border-radius: 30px;\n  background-color: transparent;\n  opacity: 1;\n  transition all .2s ease;\n  ", "\n\n  &.active {\n    color: #ffffff;\n    transform: translate(-45%,-50%);\n    background-color: #3B5A68;\n  }\n\n  &::selection {\n    background: transparent;\n  }\n\n  &>span {\n    top: -1px;\n    position: relative;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  &.rc-slider {\n    margin: 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { media, styled } from "@styles";
import Slider from "rc-slider";
import { customSliderStyles } from "../Range/styles";
export var StyledSlider = styled(Slider)(_templateObject(), customSliderStyles);
export var StyledTooltip = styled.div(_templateObject2(), media.xxLargeScreen(_templateObject3()));